import React from 'react';
import { clsx } from 'clsx';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  description?: string;
  error?: string;
}

export function Checkbox({
  label,
  description,
  error,
  className,
  id,
  ...props
}: CheckboxProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div className="relative flex items-start">
      <div className="flex h-6 items-center">
        <input
          id={inputId}
          type="checkbox"
          className={clsx(
            'h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-600 dark:border-gray-700',
            error && 'border-red-300',
            className
          )}
          {...props}
        />
      </div>
      {(label || description) && (
        <div className="ml-3 text-sm leading-6">
          {label && (
            <label
              htmlFor={inputId}
              className={clsx(
                'font-medium',
                error ? 'text-red-900' : 'text-gray-900 dark:text-gray-100'
              )}
            >
              {label}
            </label>
          )}
          {description && (
            <p className={clsx('text-gray-500 dark:text-gray-400', error && 'text-red-500')}>
              {description}
            </p>
          )}
          {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>
      )}
    </div>
  );
}
